import { useAuth } from '@clerk/nextjs';
import { useQuery } from '@tanstack/react-query';
import { Query } from '@web/constants/query';
import axios from 'axios';

interface ApiResponse {
  success: true;
  noCcTrialEnabled: boolean;
}

/**
 * Platform-wide no-card trial switch. Enabled for any signed-in user, org or not, because the
 * company-setup step runs before the organisation exists. Errors resolve to `undefined`, which
 * callers default to `false` — an unreachable API means today's flow, never a broken page.
 */
const useSignupConfig = () => {
  const { userId } = useAuth();

  return useQuery({
    queryKey: [Query.AppKeys['signup-config'], { userId }],
    enabled: !!userId,
    retry: 1,
    refetchOnWindowFocus: false,
    staleTime: 60 * 1000,
    queryFn: async () => {
      const response = await axios.get<ApiResponse>(
        `${process.env.NEXT_PUBLIC_API_APP_ENDPOINT}/platform/signup-config`,
      );

      return response.data.noCcTrialEnabled === true;
    },
  });
};

export { useSignupConfig };
